import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FriendbuyWidgetContainer } from 'components/Friendbuy/FriendbuyWidgetContainer';

export class ReferModal extends PureComponent {
  state = {
    isOpen: this.props.isOpen,
  };

  handleCloseClick = () => this.setState({ isOpen: false });

  render() {
    return this.state.isOpen && <FriendbuyWidgetContainer onClose={this.handleCloseClick} />;
  }
}

ReferModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};
